import { all, call, put, takeEvery, takeLatest } from "redux-saga/effects";
import {
  LISTA_ESCOLAS_REMATRICULA,
  LISTA_CURSOS_REMATRICULA,
  LISTA_SERIES_REMATRICULA,
  LISTA_TURMAS_ORIGEM_REMATRICULA,
  LISTA_ANOS_DESTINO_REMATRICULA,
  LISTA_TURMAS_DESTINO_REMATRICULA,
  SALVA_REMATRICULA,
  VERIFICA_SEQUENCIA_ENTURMACAO,
  LISTA_TURMAS_FILTRO_REMATRICULA,
  LISTA_REMATRICULA,
  DETALHE_REMATRICULA
} from "constants/ActionTypes";
import requisicaoApi from 'util/Api';
import {
  listaEscolasRematriculaSucesso,
  listaCursosRematriculaSucesso,
  listaSeriesRematriculaSucesso,
  listaTurmasOrigemRematriculaSucesso,
  listaAnosDestinoRematriculaSucesso,
  listaTurmasDestinoRematriculaSucesso,
  salvaRematriculaSucesso,
  verificaSequenciaEnturmacaoSucesso,
  listaTurmasFiltroRematriculaSucesso,
  listaRematriculaSucesso,
  detalheRematriculaSucesso,
  exibirMensagemErro,
  showLoader,
  showSuccessMessage
} from "actions/Rematricula";

const getMensagemErro = (ret, fallback) => {
  const status = ret && ret.response && ret.response.status;
  const data = ret && ret.response && ret.response.data;

  if (status === 400 || status === 406) {
    const inconsistencias = (data && data.inconsistencias) || [];
    if (Array.isArray(inconsistencias) && inconsistencias.length > 0) {
      return inconsistencias[0].mensagem || JSON.stringify(data);
    }
    return (data && (data.mensagem || data.message)) ? (data.mensagem || data.message) : JSON.stringify(data);
  }

  if (ret && ret.message) return JSON.stringify(ret.message);
  return fallback || 'Falha na operação.';
};

function* listaEscolas() {
  try {
    yield put(showLoader());
    const response = yield call(requisicaoApi.get, '/escolas');
    yield put(listaEscolasRematriculaSucesso(response.data));
  } catch (error) {
    yield put(exibirMensagemErro(getMensagemErro(error, 'Erro ao listar escolas')));
  }
}

function* listaCursos({ payload: escolaId }) {
  try {
    yield put(showLoader());
    // Ajuste conforme rota real: pode ser /escolas/{id}/cursos ou /cursos?escolaId={id}
    const response = yield call(requisicaoApi.get, `/escolas/${escolaId}/cursos`);
    yield put(listaCursosRematriculaSucesso(response.data));
  } catch (error) {
    yield put(exibirMensagemErro(getMensagemErro(error, 'Erro ao listar cursos')));
  }
}

function* listaSeries({ payload: cursoId }) {
  try {
    yield put(showLoader());
    const response = yield call(requisicaoApi.get, `/series?CursoId=${cursoId}`);
    yield put(listaSeriesRematriculaSucesso(response.data));
  } catch (error) {
    yield put(exibirMensagemErro(getMensagemErro(error, 'Erro ao listar séries')));
  }
}

function* listaTurmasOrigem({ payload }) {
  try {
    yield put(showLoader());
    
    let params = {};
    if (typeof payload === 'object') {
      params = {
        EscolaId: payload.escolaId,
        CursoId: payload.cursoId,
        SerieId: payload.serieId,
        SeriesId: payload.serieId
      };
    } else {
      params = { SerieId: payload, SeriesId: payload };
    }

    const response = yield call(requisicaoApi.get, '/turmas', { params });
    yield put(listaTurmasOrigemRematriculaSucesso(response.data));
  } catch (error) {
    yield put(exibirMensagemErro(getMensagemErro(error, 'Erro ao listar turmas de origem')));
  }
}

function* listaAnosDestino({ payload: escolaId }) {
  try {
    yield put(showLoader());
    const response = yield call(requisicaoApi.get, `/escolas/${escolaId}/anos-letivos`);
    yield put(listaAnosDestinoRematriculaSucesso(response.data));
  } catch (error) {
    yield put(exibirMensagemErro(getMensagemErro(error, 'Erro ao listar anos letivos')));
  }
}

function* listaTurmasDestino({ payload }) {
  const { escolaId, serieId, ano } = payload;
  try {
    yield put(showLoader());
    // Filtro complexo geralmente vai via query params
    const response = yield call(requisicaoApi.get, '/turmas', {
      params: {
        escolaId,
        serieId,
        ano
      }
    });
    yield put(listaTurmasDestinoRematriculaSucesso(response.data));
  } catch (error) {
    yield put(exibirMensagemErro(getMensagemErro(error, 'Erro ao listar turmas de destino')));
  }
}

function* salvaRematricula({ payload }) {
  try {
    yield put(showLoader());
    const response = yield call(requisicaoApi.post, '/rematriculas/lote', payload);
    yield put(salvaRematriculaSucesso('Rematrícula realizada com sucesso!'));
  } catch (error) {
    yield put(exibirMensagemErro(getMensagemErro(error, 'Erro ao realizar rematrícula')));
  }
}

function* verificaSequenciaEnturmacao({ payload }) {
  const { cursoId, serieId } = payload;
  try {
    yield put(showLoader());
    const response = yield call(requisicaoApi.get, '/sequencias-enturmacao', {
      params: {
        cursoOrigemId: cursoId,
        serieOrigemId: serieId
      }
    });

    const data = response.data;
    
    // Verifica se retornou vazio ou array vazio
    if (!data || (Array.isArray(data) && data.length === 0)) {
       yield put(exibirMensagemErro('A série escolhida ainda não possui uma sequência de enturmação definida.'));
    } else {
       // Se retornou array, pega o primeiro, se objeto usa direto
       const sequencia = Array.isArray(data) ? data[0] : data;
       yield put(verificaSequenciaEnturmacaoSucesso(sequencia));
    }
    
  } catch (error) {
    yield put(exibirMensagemErro(getMensagemErro(error, 'Erro ao verificar sequência de enturmação')));
  }
}

function* listaTurmasFiltro({ payload: escolaId }) {
  try {
    yield put(showLoader());
    const response = yield call(requisicaoApi.get, '/turmas', { params: { EscolaId: escolaId } });
    yield put(listaTurmasFiltroRematriculaSucesso(response.data));
  } catch (error) {
    yield put(exibirMensagemErro(getMensagemErro(error, 'Erro ao listar turmas da escola')));
  }
}

function* listaRematricula({ payload }) {
  try {
    yield put(showLoader());
    // Se o payload for filtros, podemos passar como params. 
    // O endpoint GET /api/rematriculas/lotes/resumo foi passado sem params no exemplo, 
    // mas se houver filtros, eles devem ir no objeto params.
    const response = yield call(requisicaoApi.get, '/rematriculas/lotes/resumo', { params: payload });
    yield put(listaRematriculaSucesso(response.data));
  } catch (error) {
    yield put(exibirMensagemErro(getMensagemErro(error, 'Erro ao listar rematrículas')));
  }
}

function* detalheRematricula({ payload: id }) {
  try {
    yield put(showLoader());
    const response = yield call(requisicaoApi.get, `/rematriculas/lotes/${id}`);
    yield put(detalheRematriculaSucesso(response.data));
  } catch (error) {
    yield put(exibirMensagemErro(getMensagemErro(error, 'Erro ao obter detalhes da rematrícula')));
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(LISTA_ESCOLAS_REMATRICULA, listaEscolas),
    takeLatest(LISTA_CURSOS_REMATRICULA, listaCursos),
    takeLatest(LISTA_SERIES_REMATRICULA, listaSeries),
    takeLatest(LISTA_TURMAS_ORIGEM_REMATRICULA, listaTurmasOrigem),
    takeLatest(LISTA_ANOS_DESTINO_REMATRICULA, listaAnosDestino),
    takeLatest(LISTA_TURMAS_DESTINO_REMATRICULA, listaTurmasDestino),
    takeLatest(SALVA_REMATRICULA, salvaRematricula),
    takeLatest(VERIFICA_SEQUENCIA_ENTURMACAO, verificaSequenciaEnturmacao),
    takeLatest(LISTA_TURMAS_FILTRO_REMATRICULA, listaTurmasFiltro),
    takeLatest(LISTA_REMATRICULA, listaRematricula),
    takeLatest(DETALHE_REMATRICULA, detalheRematricula)
  ]);
}
